import "styles/components/Navbar.sass";
export const Navbar = () => {

    return (
        <div className="navbar">
            <a href="/" className="logo">MOOSIQUE</a>
        </div>
    )
}